if (!customElements.get('custom-carousel')) {
  customElements.define(
    'custom-carousel',
    class CustomCarousel extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderWrapper = this.querySelector('.custom-carousel__slider');
        this.slidesContainer = this.querySelector('.custom-carousel__slides');

        if (!this.sliderWrapper || !this.slidesContainer) return;

        this.initSlider();

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            if (event.target.closest(`[data-section-id="${this.dataset.sectionId}"]`)) {
              const index = parseInt(event.target.dataset.index);
              if (this.sliderInstance && this.sliderInstance.slider) {
                this.sliderInstance.slider.slideTo(index);
              }
            }
          });
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = FoxTheme.utils.getGridColumnGap(this.slidesContainer);
        const autoplay = parseInt(this.dataset.autoplay || '0');

        const sliderOptions = {
          slidesPerView: 1.5,
          spaceBetween: columnGap.mobile,
          breakpoints: {
            768: {
              slidesPerView: 2.5,
              spaceBetween: columnGap.tablet,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: columnGap.tabletLarge,
            },
            1280: {
              slidesPerView: 4,
              spaceBetween: columnGap.desktop,
            },
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          threshold: 2,
          watchOverflow: true,
          grabCursor: true,
          simulateTouch: true,
          allowTouchMove: true,
        };

        const additionalModules = [];

        if (autoplay > 0) {
          sliderOptions.autoplay = {
            delay: autoplay,
            disableOnInteraction: false,
          };
          additionalModules.push(FoxTheme.Swiper.Autoplay);
        }

        this.sliderWrapper.classList.add('swiper');
        this.slidesContainer.classList.add('swiper-wrapper');

        this.sliderInstance = new window.FoxTheme.Carousel(
          this.sliderWrapper,
          sliderOptions,
          additionalModules.length ? additionalModules : null
        );
        this.sliderInstance.init();
      }

      disconnectedCallback() {
        if (typeof this.sliderInstance === 'object' && this.sliderInstance.slider) {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }
    }
  );
}
